import './player/bootstrap'

import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import Locales from './vue-i18n-locales.generated.js'
import VueRouter from 'vue-router'
import App from './player/App'

window.Vue = Vue

import routes from './player/router'
import state from './player/store/index'
import Api from './api/player'

const store = new Vuex.Store(state)

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

Vue.use(VueRouter)
Vue.use(vuexI18n.plugin, store)
Vue.use(Api)

Vue.i18n.add('en', Locales.en)
Vue.i18n.add('pl', Locales.pl)

const lang = document.documentElement.lang.substr(0, 2)

Vue.i18n.set(lang)

if (process.env.MIX_ENV === 'production') {
  Sentry.init({
    environment: process.env.MIX_ENV || 'local',
    dsn: 'https://bf89147d9a8a451abb5560c7cca457dd@glitchtip.skyier.pl/2',
    tracesSampleRate: 0.25,
    beforeSend(event, hint) {
      const error = hint.originalException
      if (
        error &&
        error.message &&
        (error.message.match(/Request failed with status code 419/i) ||
          error.message.match(/Network Error/i))
      ) {
        return null
      }

      return event
    },
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // Generic error code from errors outside the security sandbox
      // You can delete this if using raven.js > 1.0, which ignores these automatically.
      'Script error.',
      // Avast extension error
      '_avast_submit',
    ],
    denyUrls: [
      // Google Adsense
      /pagead\/js/i,
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
      /www\.googletagmanager\.com\/gtag\/js/i,
      /www\.googletagmanager\.com\/gtm\/js/i,  
    ],
    allowUrls: [
      /https?:\/\/.*\/js\/checkout\.js/i,
      /https?:\/\/.*\/js\/web-app\.js/i,
      /https?:\/\/.*\/js\/exam-app\.js/i,
      /https?:\/\/.*\/js\/player-app\.js/i,
      /https?:\/\/.*\/js\/manifest\.js/i,
      /https?:\/\/.*\/js\/vendor\.js/i,
      /https?:\/\/.*\/js\/app2\.js/i,
      /https?:\/\/.*\/js\/quill-s\.js/i,
    ],  
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
        logErrors: true,
      }),
      new Integrations.CaptureConsole({
        levels: ['error'],
      }),
    ],
  })
}

const app = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
})


// Service Worker Registration
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/sw.js')
//       .then((registration) => {
//         console.log('SW registered:', registration.scope)
//       })
//       .catch((error) => {
//         console.log('SW registration failed:', error)
//       })
//   })
// }

export default app
